import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Bitte wählen Sie die Infrastruktur aus in die Sie sich einloggen möchten:", -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" WEITER ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, { "label-position": "top" }, {
    default: _withCtx(() => [
      (_ctx.infraUrls.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_el_select, {
              modelValue: _ctx.selectedInfraUrl,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedInfraUrl) = $event)),
              onChange: _ctx.infraSelected,
              placeholder: "Bitte auswählen",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infraUrls, (infra, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: i,
                    label: infra.infraUrl,
                    value: infra.infraUrl
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_form_item, { label: "Kundennummer" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.customerId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customerId) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "Kundennummer",
                  type: "text",
                  onKeyup: _withKeys(_ctx.identifyUser, ["enter"]),
                  onKeypress: _ctx.checkIsInteger,
                  e2e: "customerNumber",
                  autofocus: ""
                }, null, 8, ["modelValue", "onKeyup", "onKeypress"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Nutzer" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.username,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.username) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "Nutzer",
                  type: "text",
                  onKeyup: _withKeys(_ctx.identifyUser, ["enter"]),
                  onChange: _ctx.trimHash,
                  e2e: "user"
                }, null, 8, ["modelValue", "onKeyup", "onChange"])
              ]),
              _: 1
            })
          ])),
      _createVNode(_component_el_button, {
        class: "w-full",
        type: "primary",
        onClick: _ctx.identifyUser,
        disabled: _ctx.disableProceedBtn
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _: 1
  }))
}